// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3gnuZ","vLegacy":"SelectSecondary_vLegacy__2GWdw","error":"SelectSecondary_error__2o1vS","disabled":"SelectSecondary_disabled__33_sU"};